<template>
  <div class="setting-main-container">
      <div class="card setting-card">
        <div class="page-header">
          <h3 class="page-title">{{ $t('accounts.shipping_address') }}</h3>
        </div>
        <div class="row">
          <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('accounts.name') }}</label>
            <p v-if="viewAccount && viewAccount.shipping_address && viewAccount.shipping_address.name !=null">{{ viewAccount.shipping_address.name }}</p>
          </div>
          <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('accounts.country') }}</label>
            <p v-if="viewAccount && viewAccount.shipping_address && viewAccount.shipping_address.country !=null">{{ viewAccount.shipping_address.country.name }}</p>
          </div>
          <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('accounts.state') }}</label>
            <p v-if="viewAccount && viewAccount.shipping_address && viewAccount.shipping_address.state !=null">{{ viewAccount.shipping_address.state }}</p>
          </div>
           <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('accounts.city') }}</label>
            <p v-if="viewAccount && viewAccount.shipping_address && viewAccount.shipping_address.city !=null">{{ viewAccount.shipping_address.city }}</p>
          </div>
          <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('general.street_1') }}</label>
            <p v-if="viewAccount && viewAccount.shipping_address && viewAccount.shipping_address.address_street_1 !=null">{{ viewAccount.shipping_address.address_street_1 }}</p>
          </div>
          <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('general.street_2') }}</label>
            <p v-if="viewAccount && viewAccount.shipping_address && viewAccount.shipping_address.address_street_2 !=null">{{ viewAccount.shipping_address.address_street_2 }}</p>
          </div>
          <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('accounts.phone') }}</label>
            <p v-if="viewAccount && viewAccount.shipping_address && viewAccount.shipping_address.phone !=null">{{ viewAccount.shipping_address.phone }}</p>
          </div>
          <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('accounts.zip_code') }}</label>
            <p v-if="viewAccount && viewAccount.shipping_address && viewAccount.shipping_address.zip !=null">{{ viewAccount.shipping_address.zip }}</p>
          </div>
        </div>
      </div>
  </div>
</template>
<script>

import { validationMixin } from 'vuelidate'
import { mapActions,mapGetters } from 'vuex'
const { required, email, maxLength, numeric } = require('vuelidate/lib/validators')

export default {
  mixins: [validationMixin],
  data () {
    return {
        isLoading: false,
    }
  },
  computed: {
     ...mapGetters('account', [
      'viewAccount'
    ]),
  }, 
  created() {
  },
  validations: {},
  mounted () {},
  methods: {}
}
</script>
